module.exports = __webpack_public_path__ + "static/media/icon_report_white.7037a4f1.png";